<ng-container *ngIf="loading; else tourItemList">
  <div class="loading">
    <mat-spinner color="primary" diameter="24"></mat-spinner>
  </div>
</ng-container>

<ng-template #tourItemList>
  <div
    *ngFor="let tourItem of tour.tourItems; trackBy: trackById"
    class="tour-item-block clickable"
    [ngClass]="tourItem.tourItemBackgroundClass"
    (click)="openTourItem(tourItem)"
  >
    <div *ngIf="tourItem.subProject != null" class="tour-item-flex">
      <div class="subproject-id block-text">
        <div>#{{ tourItem.subProject?.project?.id }}</div>
        <div
          *ngIf="tourItem.subProject?.project?.oldPlatformId != null"
          class="font-weight-bold font-italic"
          [matTooltip]="'Jobnummer oud platform'"
        >
          ({{ tourItem.subProject.project.oldPlatformId }})
        </div>
      </div>
      <div class="subproject-all-info">
        <div class="subproject-main-info">
          <div class="involved-companies">
            <ng-container
              *ngIf="
                tourItem.subProject?.project?.involvedCompanies?.length > 0
              "
            >
              <div
                class="strong company-name"
                *ngFor="
                  let company of tourItem.subProject.project.involvedCompanies
                "
              >
                {{ company.regularName }}
              </div>
            </ng-container>
            <ng-container
              *ngIf="tourItem.subProject?.latestNotExecutedHistoryItem != null"
            >
              <span class="strong not-executed"> U: uitgestelde opdracht </span>
            </ng-container>
          </div>
          <div class="block-text main-info-details">
            <ng-container
              *ngIf="
                tourItem.subProject?.type === SUB_PROJECT_TYPES.ADJUSTMENT;
                else displayProducts
              "
            >
              <div
                class="strong block-text"
                *ngIf="tourItem.subProject.extraInfoAdjustment?.length > 0"
              >
                {{ tourItem.subProject.extraInfoAdjustment | shortenText : 50 }}
              </div>
            </ng-container>
            <ng-template #displayProducts>
              <ng-container
                *ngIf="tourItem.subProject?.project?.products?.length > 0"
                class="block-text"
              >
                <div
                  *ngFor="let product of tourItem.subProject.project.products"
                >
                  <span class="strong">{{ product.typeAndMeasurements }}</span>
                  <span *ngIf="product.titleDisplay?.length > 0">
                    /
                    <span
                      [ngClass]="
                        product.hasTitleAdjustment ? 'secondary-color' : ''
                      "
                      >{{ product.titleDisplay }}</span
                    >
                  </span>
                  <span
                    *ngIf="
                      product.boardPart?.sign?.poleColor?.label?.length > 0
                    "
                  >
                    /
                    <span>{{ product.boardPart?.sign?.poleColor?.label }}</span>
                  </span>
                  <span *ngIf="product.hasSecondBoard">
                    /
                    <span class="strong">+ 2de bord</span>
                  </span>
                </div>
              </ng-container>
            </ng-template>
            <div class="block-text">
              {{
                tourItem.subProject?.projectPlacement?.address?.line1
                  | printAddress
                    : tourItem.subProject?.projectPlacement?.address?.postalCode
                    : tourItem.subProject?.projectPlacement?.address?.city
                    : tourItem.subProject?.projectPlacement?.placementFloor
              }}
            </div>
          </div>
        </div>
        <div
          class="extra-info-container"
          *ngIf="
            tourItem.subProject.internalInfo != null &&
            tourItem.subProject.internalInfo != ''
          "
        >
          <span class="internal-info">
            {{ tourItem.subProject.internalInfo }}
          </span>
        </div>
        <div
          class="extra-info-container"
          *ngIf="tourItem.subProject.projectPlacement.appointment"
          [ngClass]="
            tourItem.subProject.projectPlacement.appointmentFailure
              ? 'appointment-failed'
              : 'appointment-info'
          "
        >
          <span
            class="strong"
            *ngIf="tourItem.subProject.projectPlacement.appointmentReady"
          >
            Afspraak klaar
          </span>
          <span
            class="strong"
            *ngIf="tourItem.subProject.projectPlacement.appointmentFailure"
          >
            Geen afspraak
          </span>
          <span
            class="strong"
            *ngIf="
              !tourItem.subProject.projectPlacement.appointmentFailure &&
              !tourItem.subProject.projectPlacement.appointmentReady
            "
          >
            Afspraak niet klaar
          </span>
          <span
            *ngIf="
              tourItem.subProject.projectPlacement.appointmentTimeOfDay != null
            "
            >{{
              tourItem.subProject.projectPlacement.appointmentTimeOfDay
            }}</span
          >
          <span
            *ngIf="
              tourItem.subProject.projectPlacement.appointmentTimeOfDay !=
                null &&
              tourItem.subProject.projectPlacement.needAppointmentInfo?.length >
                0
            "
          >
            /
          </span>
          <span
            *ngIf="tourItem.subProject.projectPlacement.needAppointmentInfo"
          >
            {{ tourItem.subProject.projectPlacement.needAppointmentInfo }}
          </span>
        </div>
        <div
          class="extra-info-container"
          *ngIf="tourItem.subProject.projectPlacement.collectKey"
        >
          <span class="strong key-info">Sleutel</span>
          <span
            class="key-info"
            *ngIf="
              tourItem.subProject.projectPlacement.collectKeyAddressType ===
                'primary' &&
              tourItem.subProject.appointmentTooltip != null &&
              tourItem.subProject.appointmentTooltip?.length > 0
            "
          >
            {{ tourItem.subProject.appointmentTooltip }}
          </span>
          <span
            class="key-info"
            *ngIf="
              tourItem.subProject.projectPlacement.collectKeyAddressType ==
                null &&
              tourItem.subProject.projectPlacement.collectKeyExtraInfo !=
                null &&
              tourItem.subProject.projectPlacement.collectKeyExtraInfo?.length >
                0
            "
          >
            {{ tourItem.subProject.projectPlacement.collectKeyExtraInfo }}
          </span>
        </div>
      </div>
      <div class="placement-info">
        <div class="request-date">
          {{
            tourItem.subProject?.currentRequestDate
              | printASAPDateFormat
                : tourItem.subProject?.currentRequestASAP
                : 'dd/MM/yyyy'
          }}
        </div>
        <div
          class="appointment-icon"
          *ngIf="
            tourItem.subProject?.projectPlacement?.appointment ||
            tourItem.subProject?.projectPlacement?.collectKey
          "
        >
          <mat-icon
            *ngIf="
              tourItem.subProject.projectPlacement.appointment &&
              tourItem.subProject.appointmentTooltip != null &&
              tourItem.subProject.appointmentTooltip?.length > 0
            "
            class="appointment-info-icon"
            [matTooltip]="tourItem.subProject.appointmentTooltip"
            [ngClass]="
              tourItem.subProject.projectPlacement.collectKey
                ? 'key-appointment'
                : 'time-of-day-appointment'
            "
            #tooltip="matTooltip"
            (click)="$event.stopPropagation(); tooltip.toggle()"
          >
            info
          </mat-icon>
          <ng-container
            *ngIf="
              tourItem.subProject.projectPlacement.appointment &&
                !tourItem.subProject.projectPlacement.collectKey;
              else keyAppointment
            "
          >
            <div class="strong appointment-time">
              {{ tourItem.subProject.appointmentTime | shortenText : 20 }}
            </div>
          </ng-container>
          <ng-template #keyAppointment>
            <img
              class="key-icon"
              src="../../../../../../assets/collect-key.png"
            />
          </ng-template>
        </div>
      </div>
      <div class="type-display-container">
        <div
          class="type-display-content"
          [ngClass]="tourItem.subProject.typeClass"
        >
          <span>{{ tourItem.subProject.typeDisplay }}</span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="tourItem.immoTask != null">
      <div class="tour-item-flex">
        <div class="subproject-id block-text">#{{ tourItem.immoTask.id }}</div>
        <div class="subproject-all-info">
          <div class="subproject-main-info">
            <div class="strong company-name">
              <div
                *ngIf="tourItem.immoTask.requestingUser != null"
                class="strong"
              >
                {{
                  tourItem.immoTask.requestingUser.firstName
                    | personName : tourItem.immoTask.requestingUser.lastName
                }}
              </div>
            </div>
            <div class="block-text main-info-details">
              <div class="strong block-text">
                {{ tourItem.immoTask.subject | shortenText : 50 }}
              </div>

              <div class="block-text">
                {{
                  tourItem.immoTask.address?.line1
                    | printAddress
                      : tourItem.immoTask.address?.postalCode
                      : tourItem.immoTask.address?.city
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="placement-info">
          <div class="request-date">
            {{
              tourItem.immoTask.requestedDate
                | printASAPDateFormat
                  : tourItem.immoTask.requestedASAP
                  : 'dd/MM/yyyy'
            }}
          </div>
          <div class="appointment-icon">
            <mat-icon
              *ngIf="tourItem.immoTask.description?.length > 0"
              class="appointment-info-icon time-of-day-appointment"
              [matTooltip]="tourItem.immoTask.description"
              #tooltip="matTooltip"
              (click)="$event.stopPropagation(); tooltip.toggle()"
            >
              info
            </mat-icon>
            <div
              *ngIf="tourItem.immoTask.executionTime != null"
              class="strong secondary-color"
            >
              {{ tourItem.immoTask.executionTime | slice : 0 : 5 }}
            </div>
          </div>
        </div>
        <div class="type-display-container">
          <div class="type-display-content immo-task">
            <span>Taak</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
